import client from '@/api/client.js'
import store from "@/store";

export default {
    methods: {
        async getCheckListTemplate(templateId) {
            var response = await client().get(store.state.apiRouteRoot + "checklist/templates/" + templateId)
            return response.data;
        },
        async getCheckListEntry(entryId) {
            var response = await client().get(store.state.apiRouteRoot + "checklist/?entryId=" + entryId)
            return response.data;
        },
        async getCheckListForJob(jobId) {
            var response = await client().get(store.state.apiRouteRoot + "checklist/list?jobId=" + jobId)
            return response.data;
        },
        async startCheckListForJob(jobId, templateId) {
            var response = await client().post(store.state.apiRouteRoot + "checklist/start?jobId=" + jobId + "&templateId=" + templateId)
            return response.data;
        },
        async getCheckListTemplates() {
            var response = await client().get(store.state.apiRouteRoot + "checklist/templates")
            return response.data;
        },
        async createCheckList(name) {
            var response = await client().post(store.state.apiRouteRoot + "checklist/templates/?name=" + encodeURIComponent(name));
            return response.data;
        },
        async addCheckListTemplateField(templateId) {
            var response = await client().post(store.state.apiRouteRoot + `checklist/templates/${templateId}/`);
            return response.data;
        },
        async updateCheckListField(entry) {
            var response = await client().patch(store.state.apiRouteRoot + `checklist/field/`, entry);
            return response.data;
        },
    }
}
